// lib/katex-macros.ts

export const KATEX_MACROS = {
  "\\RR": "\\mathbb{R}",
  "\\vect": ["\\mathbf{#1}", 1],
  "\\lbrace": "\\{",
  "\\rbrace": "\\}",
};
